import { useMemo } from 'react';
import type { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import type { CreativeText } from '../types';
import { format } from 'date-fns';
import { CellContainer, CellTypography } from '../components/CreativeTextsGrid.styles';

const columnsAdditionalOptions = {
  disableColumnFilter: true,
  disableColumnMenu: true,
};

export const useCreativeTextsColumns = (): GridColDef[] => {
  return useMemo(
    () => [
      {
        field: 'tag',
        headerName: 'Tag',
        width: 80,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).tag || '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'text',
        headerName: 'Text',
        width: 700,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer
            sx={{ flexDirection: 'column', justifyContent: 'center' }}
          >
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).title}
            </CellTypography>
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).body}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'app',
        headerName: 'App',
        width: 160,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).app ?? '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'flows',
        headerName: 'Flows',
        width: 120,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).flows_count}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'default_flow',
        headerName: 'Default for flow',
        width: 200,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {(params.row as CreativeText).default_flows.join(', ') || '-'}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
      {
        field: 'created_at',
        headerName: 'Created',
        width: 120,
        sortable: false,
        renderCell: (params: GridRenderCellParams) => (
          <CellContainer>
            <CellTypography variant={'body2'}>
              {format(
                new Date((params.row as CreativeText).created_at),
                'yyyy-MM-dd',
              )}
            </CellTypography>
          </CellContainer>
        ),
        ...columnsAdditionalOptions,
      },
    ],
    [],
  );
};
